/**
 * <StatTile> — one number with its label: the row of tiles across the top of a results
 * card (ผ่านรีวิวแล้ว 208 · โทรแล้ว 14 · นัดได้ 4). Added 2026-10-29: /reports/implant had
 * its own clickable tile and needed a second, read-only one for the ผลการโทร tab.
 *
 *   label    what is counted
 *   value    the number, already formatted — '—' when it could not be loaded, never 0
 *   sub      one short line under it (a rate, a sub-count)
 *   tone     'default' · 'good' (the outcome that matters: นัดได้, จ่ายแล้ว) · 'warn'
 *   onClick  makes the tile a filter button; `active` marks the chosen one
 *
 * Lay tiles out in a grid (grid-cols-2 sm:grid-cols-4 …) so they line up across rows.
 */
const VALUE_TONE = { default: 'text-slate-800', good: 'text-emerald-700', warn: 'text-amber-700' }

export function StatTile({ label, value, sub, tone = 'default', onClick, active = false, className = '' }) {
  const box = `rounded-xl border px-3 py-2 text-left ${active ? 'border-brand-300 bg-brand-50/60' : 'border-slate-200 bg-white'} ${className}`
  const inner = (
    <>
      <span className="block text-[11.5px] text-slate-500">{label}</span>
      <span className={`block text-[18px] font-semibold tabular-nums leading-tight ${VALUE_TONE[tone] || VALUE_TONE.default}`}>{value}</span>
      {sub && <span className="block text-[11px] text-slate-400">{sub}</span>}
    </>
  )
  if (!onClick) return <div className={box}>{inner}</div>
  return (
    <button type="button" onClick={onClick} aria-pressed={active}
      className={`${box} transition ${active ? '' : 'hover:border-slate-300'}`}>
      {inner}
    </button>
  )
}
